module.exports = __webpack_public_path__ + "static/media/ieee-cs-logo.a7b9bc3a.png";